/**
 * AppHeader — Wraps GlobalHeader for Gamin ENGINE with Clerk auth state.
 *
 * Uses useAuth() for a single GlobalHeader instance that adapts buttons
 * based on authentication state — avoids mounting two header instances.
 */

import { useAuth, useClerk } from '@clerk/clerk-react';
import { GlobalHeader, type GlobalHeaderProps } from '@engagexp/legendary-ui-primitives';
import { navLinks, mobileBottomBar } from '~/config/nav';

export function AppHeader() {
  const { isSignedIn } = useAuth();
  const { openSignIn, openSignUp } = useClerk();

  const buttons: GlobalHeaderProps['buttons'] = isSignedIn
    ? [{ title: 'Dashboard', variant: 'primary', size: 'sm', href: '/dashboard' }]
    : [
        { title: 'Log In', variant: 'secondary', size: 'sm', onClick: () => openSignIn() },
        { title: 'Start Free', variant: 'primary', size: 'sm', onClick: () => openSignUp() },
      ];

  return (
    <GlobalHeader
      logo={{ src: 'https://placehold.co/140x36/121212/3bd80d?text=Gamin+ENGINE', alt: 'Gamin ENGINE', href: '/' }}
      logoNode={
        <span style={{ display: 'flex', alignItems: 'baseline', gap: '3px', fontFamily: 'var(--exp-font-display)', fontSize: '20px', lineHeight: 1, letterSpacing: '-0.01em' }}>
          <span style={{ fontWeight: 400, color: 'var(--foreground)' }}>Gamin</span>
          <span style={{ fontWeight: 700, color: 'var(--primary)' }}>ENGINE</span>
        </span>
      }
      navLinks={navLinks}
      buttons={buttons}
      mobileBottomBar={mobileBottomBar}
    />
  );
}

AppHeader.displayName = 'AppHeader';
